module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 22.456 23.323",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }